export const SOON = 1000 * 3600 * 24 * 7; // 1 week
